// Marker attributes to designate excluded/masked elements in the recording stream,
//   referenced during replay in fsstyles.main.scss.
export const AttrExcluded = '_fs_excluded';
export const AttrMasked = '_fs_masked';
export const AttrDeferred = '_fs_deferred';
